"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2861],{

/***/ 22861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Auth_SignUpView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconNzxtLogo.js
var IconNzxtLogo = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconGoogle.js
var IconGoogle = __webpack_require__(61311);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
// EXTERNAL MODULE: ./components/Button/index.ts + 3 modules
var Button = __webpack_require__(60820);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(82346);
// EXTERNAL MODULE: ./components/Input/index.ts + 2 modules
var Input = __webpack_require__(11282);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./utils/slugify.ts
var slugify = __webpack_require__(10907);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Select/styles.ts


var isSrOnly = (0,tailwindcss_classnames/* classnames */.d)("mt-2.5");
var isDisabled = (0,tailwindcss_classnames/* classnames */.d)("cursor-not-allowed");
var isInlineLabel = (0,tailwindcss_classnames/* classnames */.d)("rounded-none", "rounded-r-md");
var defaultBorder = (0,tailwindcss_classnames/* classnames */.d)("rounded-md");
var invertedStyles = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-800", "!text-white", "!bg-blend-luminosity", "border-nzxt-dark-grey-400", "focus:outline-none", "focus:ring-nzxt-volt-200", "focus:border-nzxt-volt-200");
var defaultSelectBorder = (0,tailwindcss_classnames/* classnames */.d)("border-gray-300", "focus:outline-none", "focus:ring-nzxt-volt-400", "focus:border-nzxt-volt-400");
var nativeSelect = function(srOnly, disabled, inlineLabel, isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, isSrOnly, !srOnly), (0,_define_property/* default */.Z)(_obj, isDisabled, disabled), (0,_define_property/* default */.Z)(_obj, isInlineLabel, inlineLabel), (0,_define_property/* default */.Z)(_obj, defaultBorder, !inlineLabel), (0,_define_property/* default */.Z)(_obj, invertedStyles, isInverted), (0,_define_property/* default */.Z)(_obj, defaultSelectBorder, !isInverted), _obj), "block", "w-full", "pl-3", "pr-10", "py-2", "text-base", "placeholder-gray-400", "sm:text-sm");
};
var textGray700 = (0,tailwindcss_classnames/* classnames */.d)("text-gray-700");
var textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var selectLabelClass = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("block", "text-sm", "font-medium", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textWhite, isInverted), (0,_define_property/* default */.Z)(_obj, textGray700, !isInverted), _obj));
};
var defaultInlineLabel = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-50", "text-nzxt-dark-grey-400");
var invertedInlineLabel = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-700", "text-nzxt-light-grey-200", "!border-nzxt-dark-grey-400");
var styles_inlineLabel = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, invertedInlineLabel, isInverted), (0,_define_property/* default */.Z)(_obj, defaultInlineLabel, !isInverted), _obj), "inline-flex", "items-center", "px-3", "rounded-l-md", "border", "border-r-0");
};
var wrapper = (0,tailwindcss_classnames/* classnames */.d)("max-w-lg", "flex", "rounded-md", "shadow-sm");
var errorText = (0,tailwindcss_classnames/* classnames */.d)("text-red-500", "mt-2", "text-xs");

;// CONCATENATED MODULE: ./components/Select/Select.tsx








var Select = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var classes = _param.classes, labelFor = _param.labelFor, selectLabel = _param.selectLabel, options = _param.options, selectValue = _param.selectValue, srOnlyLabel = _param.srOnlyLabel, disabled = _param.disabled, inlineLabel = _param.inlineLabel, _isInverted = _param.isInverted, isInverted = _isInverted === void 0 ? false : _isInverted, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "classes",
        "labelFor",
        "selectLabel",
        "options",
        "selectValue",
        "srOnlyLabel",
        "disabled",
        "inlineLabel",
        "isInverted"
    ]);
    var rootClassName = (0,clsx_m/* default */.Z)(nativeSelect(srOnlyLabel, disabled, !!inlineLabel, isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.optionsClass);
    var labelClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(selectLabelClass(isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.labelClass);
    }, [
        classes
    ]);
    var wrapperClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(wrapper, {}, classes === null || classes === void 0 ? void 0 : classes.wrapperClass);
    }, [
        classes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: labelFor,
        className: labelClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: srOnlyLabel ? "sr-only" : null,
                children: selectLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: wrapperClassName,
                children: [
                    inlineLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: styles_inlineLabel(isInverted),
                        children: inlineLabel
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        id: (0,slugify/* default */.Z)(labelFor),
                        name: labelFor,
                        className: rootClassName,
                        value: selectValue,
                        disabled: disabled,
                        ref: ref
                    }, rest), {
                        children: options.map(function(c, i) {
                            return(// eslint-disable-next-line react/no-array-index-key
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: c.value,
                                children: c.label
                            }, "".concat(c.value, "-").concat(i, "s")));
                        })
                    }))
                ]
            })
        ]
    });
});
/* harmony default export */ var Select_Select = (/*#__PURE__*/(0,react.memo)(Select));

;// CONCATENATED MODULE: ./components/Select/index.ts

/* harmony default export */ var components_Select = (Select_Select);

;// CONCATENATED MODULE: ./components/CheckboxInput/styles.ts


var bgGrey700 = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-700");
var input = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("h-4", "w-4", "text-nzxt-volt-400", "focus:text-nzxt-volt-400", "border-gray-600", "rounded", "focus:outline-none", "focus:ring-nzxt-volt-400", "focus:border-nzxt-volt-400", "disabled:bg-nzxt-light-grey-100", (0,_define_property/* default */.Z)({}, bgGrey700, isInverted));
};
var styles_checkBoxLabel = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center", "text-sm");
var styles_textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var checkBoxText = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("ml-2", (0,_define_property/* default */.Z)({}, styles_textWhite, isInverted));
};
var styles_errorText = (0,tailwindcss_classnames/* classnames */.d)("text-red-500", "mt-2", "ml-6", "text-xs");

;// CONCATENATED MODULE: ./components/CheckboxInput/CheckboxInput.tsx







var CheckboxInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var classes = _param.classes, labelFor = _param.labelFor, checkBoxLabel = _param.checkBoxLabel, requiredError = _param.requiredError, requiredMessage = _param.requiredMessage, isInverted = _param.isInverted, srOnly = _param.srOnly, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "classes",
        "labelFor",
        "checkBoxLabel",
        "requiredError",
        "requiredMessage",
        "isInverted",
        "srOnly"
    ]);
    var rootClassName = (0,clsx_m/* default */.Z)(input(isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.inputClass);
    var labelClassName = (0,clsx_m/* default */.Z)(styles_checkBoxLabel, {}, classes === null || classes === void 0 ? void 0 : classes.labelClass);
    var textClassname = (0,clsx_m/* default */.Z)(checkBoxText(isInverted), {
        "sr-only": srOnly
    }, classes === null || classes === void 0 ? void 0 : classes.checkBoxTextClass);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: labelFor,
                className: labelClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        type: "checkbox",
                        className: rootClassName,
                        id: labelFor
                    }, rest), {
                        ref: ref
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: textClassname,
                        children: checkBoxLabel
                    })
                ]
            }),
            requiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: styles_errorText,
                children: requiredMessage
            })
        ]
    });
});
/* harmony default export */ var CheckboxInput_CheckboxInput = (/*#__PURE__*/(0,react.memo)(CheckboxInput));

;// CONCATENATED MODULE: ./components/CheckboxInput/index.ts

/* harmony default export */ var components_CheckboxInput = (CheckboxInput_CheckboxInput);

// EXTERNAL MODULE: ./components/Checkmark/index.ts + 1 modules
var Checkmark = __webpack_require__(54038);
// EXTERNAL MODULE: ./components/Divider/index.ts + 2 modules
var Divider = __webpack_require__(96590);
// EXTERNAL MODULE: ./components/Auth/LoginView/LoginView.tsx + 5 modules
var LoginView = __webpack_require__(90655);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var utils_errors = __webpack_require__(2063);
// EXTERNAL MODULE: ./framework/utils/use-action.tsx
var use_action = __webpack_require__(62253);
;// CONCATENATED MODULE: ./framework/commerce/use-signup.tsx

var useSignup = use_action/* default */.Z;
/* harmony default export */ var use_signup = (useSignup);

// EXTERNAL MODULE: ./framework/customer/use-customer.tsx + 1 modules
var use_customer = __webpack_require__(75524);
;// CONCATENATED MODULE: ./framework/auth/use-signup.tsx
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var defaultOpts = {
    url: "/api/maxify/auth",
    method: "POST"
};
var fetcher = function(options, param, fetch) {
    var username = param.username, email = param.email, password = param.password, country = param.country, optin = param.optin, accept = param.accept, locale = param.locale, clientId = param.clientId;
    if (!(username && email && password && country && accept)) {
        throw new utils_errors/* CommerceError */.yG({
            message: "A username, email, password, country and accepting NZXT's terms are required to signup"
        });
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultOpts, options), {
        body: {
            username: username,
            email: email,
            password: password,
            country: country,
            optin: optin,
            accept: accept,
            locale: locale,
            clientId: clientId
        }
    }));
};
function extendHook(customFetcher) {
    var useSignup = function() {
        var mutate = (0,use_customer/* default */.ZP)().mutate;
        var fn = use_signup(defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _signup = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn(input);
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate();
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function signup(input) {
                return _signup.apply(this, arguments);
            }
            return signup;
        }(), [
            fn,
            mutate
        ]);
    };
    useSignup.extend = extendHook;
    return useSignup;
}
/* harmony default export */ var auth_use_signup = (extendHook(fetcher));

;// CONCATENATED MODULE: ./framework/commerce/use-check.tsx

var useCheck = use_action/* default */.Z;
/* harmony default export */ var use_check = (useCheck);

;// CONCATENATED MODULE: ./framework/auth/use-check.tsx
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var use_check_defaultOpts = {
    url: "/api/maxify/auth",
    method: "GET"
};
var use_check_fetcher = function(options, param, fetch) {
    var email = param.email, username = param.username;
    if (!email && !username) {
        throw new utils_errors/* CommerceError */.yG({
            message: "Invalid request."
        });
    }
    var checkRequestParams = new URLSearchParams();
    if (email) {
        checkRequestParams.append("email", email);
    } else {
        checkRequestParams.append("username", username);
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, use_check_defaultOpts, options), {
        url: "".concat(use_check_defaultOpts.url, "?").concat(checkRequestParams.toString())
    }));
};
function use_check_extendHook(customFetcher) {
    var useCheck = function() {
        var mutate = (0,use_customer/* default */.ZP)().mutate;
        var fn = use_check(use_check_defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _check = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn(input);
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate();
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function check(input) {
                return _check.apply(this, arguments);
            }
            return check;
        }(), [
            fn,
            mutate
        ]);
    };
    useCheck.extend = use_check_extendHook;
    return useCheck;
}
/* harmony default export */ var auth_use_check = (use_check_extendHook(use_check_fetcher));

;// CONCATENATED MODULE: ./components/Auth/SignUpView/styles.ts


var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var container = (0,tailwindcss_classnames/* classnames */.d)("ml-3", relative);
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var legalText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "px-6");
var textCenter = (0,tailwindcss_classnames/* classnames */.d)("text-center");
var policyLink = (0,tailwindcss_classnames/* classnames */.d)("pl-0", "pr-0", "text-xs");
var bgWhite = (0,tailwindcss_classnames/* classnames */.d)("bg-white");
var bgGrey800 = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800");
var SignUpView_styles_textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var whiteLogo = (0,tailwindcss_classnames/* classnames */.d)(SignUpView_styles_textWhite, "fill-current");
var logo = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("w-20", "h-6", "mx-auto", (0,_define_property/* default */.Z)({}, whiteLogo, isInverted));
};
var loginWrapper = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-center", "md:pt-6", "sm:px-6", "lg:px-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, bgGrey800, isInverted), (0,_define_property/* default */.Z)(_obj, bgWhite, !isInverted), _obj));
};
var standaloneWrapper = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("m-auto", "max-w-lg", "lg:py-12", "flex", "flex-col", "justify-center", "md:pt-6", "sm:px-6", "lg:px-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, bgGrey800, isInverted), (0,_define_property/* default */.Z)(_obj, bgWhite, !isInverted), _obj));
};
var loginTopCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md", "hidden", "md:block");
var loginHeading = (0,tailwindcss_classnames/* classnames */.d)("mt-2", "md:mt-6", "text-center", "text-3xl", "font-extrabold", "text-nzxt-light-grey-800");
var loginSubheading = (0,tailwindcss_classnames/* classnames */.d)("text-center", "text-sm", "text-nzxt-light-grey-600", "w-max", "mx-auto", "flex", "items-center", "mt-2", "md:mt-4");
var loginBottomCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md");
var loginFormWrapper = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-8", "sm:px-10");
var loginForm = (0,tailwindcss_classnames/* classnames */.d)("space-y-4", "mt-4");
var loginButtonWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "justify-center", "w-full");
var loginButton = (0,tailwindcss_classnames/* classnames */.d)("w-full");
var loginCheckboxWrapper = (0,tailwindcss_classnames/* classnames */.d)(flexCenter, "justify-between");
var loginContinueWithWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-4", "md:mt-6");
var loginSocialSignInWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-6", "flex", "justify-center", "px-4", "sm:px-10");
var loginSignUpWith = (0,tailwindcss_classnames/* classnames */.d)("ml-2");
var loginSvgContainer = (0,tailwindcss_classnames/* classnames */.d)("w-full", "inline-flex", "justify-center", "py-2", "border", "border-gray-300", "rounded-md", "shadow-sm", "bg-white", "text-nzxt-light-grey-600", "hover:bg-nzxt-light-grey-50");
var loginSvgStyles = (0,tailwindcss_classnames/* classnames */.d)("w-6", "h-6", "stroke-current", "text-nzxt-light-grey-600");
var loginSignUpWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-4", "flex", "items-center", "justify-center");
var loginSignUpText = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("mr-2", "text-sm", (0,_define_property/* default */.Z)({}, SignUpView_styles_textWhite, isInverted));
};
var textButton = (0,tailwindcss_classnames/* classnames */.d)("text-sm");
var errorWrapper = (0,tailwindcss_classnames/* classnames */.d)("bg-error", "p-3", "rounded-md");
var errorMessage = (0,tailwindcss_classnames/* classnames */.d)("text-white", "text-sm", "font-semibold");
var loginSuccessWrapper = (0,tailwindcss_classnames/* classnames */.d)("m-16", "sm:mx-auto", "sm:w-full", "sm:max-w-md");
var checkMark = (0,tailwindcss_classnames/* classnames */.d)("w-16", "py-2", "mx-auto");
var styles_successMessage = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-center", "text-sm", "font-semibold", (0,_define_property/* default */.Z)({}, SignUpView_styles_textWhite, isInverted));
};

;// CONCATENATED MODULE: ./components/Auth/SignUpView/SignUpView.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable no-useless-escape */ /* eslint-disable security/detect-unsafe-regex */ /* eslint-disable max-len */ 






// import { signIn } from 'next-auth/react';



// import { setUserEmailCookie } from '@utils/user-email-cookie';













// import GTM from '@utils/gtm';

var AcceptTermsLabel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,hooks/* useTranslation */.$G)("user_auth_agreement"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                target: "_blank",
                rel: "noopener noreferrer",
                href: "".concat("https://nzxt.com", "/").concat(constants/* ROUTE_LEGAL */.SyD, "/terms-of-service"),
                customMargin: true,
                className: policyLink,
                noChevron: true,
                children: (0,hooks/* useTranslation */.$G)("user_auth_terms")
            }),
            " ",
            (0,hooks/* useTranslation */.$G)("user_auth_and"),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                target: "_blank",
                rel: "noopener noreferrer",
                href: "".concat("https://nzxt.com", "/").concat(constants/* ROUTE_LEGAL */.SyD, "/privacy-policy"),
                customMargin: true,
                className: policyLink,
                noChevron: true,
                children: (0,hooks/* useTranslation */.$G)("user_auth_privacy_policy")
            })
        ]
    });
};
var SignUpView = function(param) {
    var pageType = param.pageType, isInverted = param.isInverted;
    var ref;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), successMessage = ref2[0], setSuccessMessage = ref2[1];
    var ref3 = (0,router.useRouter)(), query = ref3.query, locale = ref3.locale;
    var slug = query.slug, rawClientId = query.client_id;
    var oauthUID = Array.isArray(slug) && slug.length === 2 ? slug[1] : undefined;
    var clientId = Array.isArray(rawClientId) ? rawClientId[0] : rawClientId;
    var ref4 = (0,react.useState)(pageType === "modal" ? window.location.href : "https://nzxt.com"), callbackUrl = ref4[0], setCallbackUrl = ref4[1];
    var setModalView = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalView */.Bz);
    var signup = auth_use_signup();
    var check = auth_use_check();
    var f = (0,hooks/* useFormatMessage */.LP)();
    var ref5 = (0,index_esm/* useForm */.cI)({
        mode: "onBlur"
    }), register = ref5.register, handleSubmit = ref5.handleSubmit, getValues = ref5.getValues, clearErrors = ref5.clearErrors, setError = ref5.setError, watch = ref5.watch, formState = ref5.formState, reset = ref5.reset;
    var isDirty = formState.isDirty, isSubmitted = formState.isSubmitted, isSubmitting = formState.isSubmitting, errors = formState.errors;
    (0,react.useEffect)(function() {
        if (isDirty && isSubmitted && errors.serverError) {
            clearErrors("serverError");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDirty,
        isSubmitted,
        errors
    ]);
    (0,react.useEffect)(function() {
        if (query.callbackUrl) {
            setCallbackUrl(Array.isArray(query.callbackUrl) ? query.callbackUrl[0] : query.callbackUrl);
        }
    }, [
        query.callbackUrl
    ]);
    /*
  const gtmConfigAccountCreate = (): void => {
    const invalidUrl = ['/category/gaming-pcs/'];
    const validUrl = [
      '/build',
      'build/pc/',
      `/build/pc/${query}/`,
      '/build/keyboard/',
      `/build/keyboard/${query}/`,
    ];

    const isValidPath = validUrl.some(currentPage =>
      asPath.includes(currentPage)
    );
    const isInValidPath = invalidUrl.some(currentPage =>
      asPath.includes(currentPage)
    );

    if (!isValidPath) {
      return;
    }
    if (isInValidPath) {
      return;
    }
    GTM.dataLayer({
      dataLayer: {
        event: 'Config_AccountCreate',
      },
    });
  };
  */ var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var errors, errorMessage, errorMessageKey, ref, formValues;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return signup({
                            username: data.username,
                            email: data.email,
                            password: data.password,
                            country: data.country,
                            optin: data.optin,
                            accept: data.accept,
                            locale: locale,
                            clientId: clientId
                        });
                    case 4:
                        clearErrors();
                        setLoading(false);
                        // gtmConfigAccountCreate();
                        setSuccessMessage(f("user_sign_up_success_verify_message"));
                        _ctx.next = 19;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        errors = _ctx.t0.errors;
                        errorMessage = f("error_generic");
                        errorMessageKey = (0,utils_errors/* getErrorMessageKey */.H4)(errors);
                        if (errorMessageKey) {
                            ;
                            (ref = window.heap) === null || ref === void 0 ? void 0 : ref.track(errorMessageKey);
                            errorMessage = f(errorMessageKey);
                        }
                        formValues = getValues();
                        // react-hook-form doesn't support dirtySinceLastSubmit so have to reset
                        reset(formValues);
                        setError("serverError", {
                            type: "error",
                            message: errorMessage
                        });
                        setLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var USERNAME = (0,hooks/* useTranslation */.$G)("label_username");
    var MESSAGE_USERNAME_INVALID = (0,hooks/* useTranslation */.$G)("username_full_pattern_message");
    var MESSAGE_USERNAME_UNAVAILABLE = (0,hooks/* useTranslation */.$G)("error_username_unavailable");
    var MESSAGE_INVALID_EMAIL = (0,hooks/* useTranslation */.$G)("invalid_email");
    var MESSAGE_INVALID_PASSWORD = (0,hooks/* useTranslation */.$G)("password_pattern_message");
    var MESSAGE_PW_MUST_MATCH = (0,hooks/* useTranslation */.$G)("passwords_must_match");
    var MESSAGE_EMAIL_UNAVAILABLE = (0,hooks/* useTranslation */.$G)("error_email_exists");
    var MESSAGE_MUST_ACCEPT_TOS_TERMS = (0,hooks/* useTranslation */.$G)("must_accept_tos_terms");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageType === "standalone" ? standaloneWrapper(isInverted) : loginWrapper(isInverted),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: loginTopCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNzxtLogo/* default */.Z, {
                    className: logo(isInverted)
                })
            }),
            successMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: loginSuccessWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: checkMark,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles_successMessage(isInverted),
                        children: f("user_sign_up_check_email_message")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: styles_successMessage(isInverted),
                        children: successMessage
                    })
                ]
            }),
            !successMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: loginBottomCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: loginSocialSignInWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            type: "button",
                            buttonStyle: "textButton",
                            className: loginSvgContainer,
                            "data-test-id": "google-sign-in",
                            onClick: function() {
                                return (0,LoginView/* federatedSignIn */.t)("google", oauthUID, {
                                    callbackUrl: callbackUrl
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGoogle/* default */.Z, {
                                    className: loginSvgStyles
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: loginSignUpWith,
                                    children: (0,hooks/* useTranslation */.$G)("user_sign_up_text")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: loginFormWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                text: (0,hooks/* useTranslation */.$G)("user_email_sign_up_text"),
                                isInverted: isInverted
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                className: loginForm,
                                onSubmit: handleSubmit(onSubmit),
                                noValidate: true,
                                children: [
                                    errors.serverError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: errorWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: errorMessage,
                                            children: (ref = errors.serverError) === null || ref === void 0 ? void 0 : ref.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            id: "username",
                                            type: "text",
                                            autoComplete: "username",
                                            inputLabel: USERNAME,
                                            labelFor: "username"
                                        }, register("username", {
                                            required: true,
                                            // eslint-disable-next-line
                                            pattern: constants/* USERNAME_PATTERN_REGEX */.B6F,
                                            validate: function() {
                                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
                                                    var available;
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!isSubmitting) {
                                                                    _ctx.next = 2;
                                                                    break;
                                                                }
                                                                return _ctx.abrupt("return", true);
                                                            case 2:
                                                                _ctx.prev = 2;
                                                                _ctx.next = 5;
                                                                return check({
                                                                    username: value
                                                                });
                                                            case 5:
                                                                available = _ctx.sent.available;
                                                                return _ctx.abrupt("return", available);
                                                            case 9:
                                                                _ctx.prev = 9;
                                                                _ctx.t0 = _ctx["catch"](2);
                                                                return _ctx.abrupt("return", true);
                                                            case 12:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee, null, [
                                                        [
                                                            2,
                                                            9
                                                        ]
                                                    ]);
                                                }));
                                                return function(value) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }()
                                        })), {
                                            requiredError: errors.username && errors.username.type === "required",
                                            patternMessage: (0,hooks/* useTranslation */.$G)("username_min_length_message"),
                                            patternError: errors.username && errors.username.type === "pattern" && MESSAGE_USERNAME_INVALID,
                                            generalError: errors.username && errors.username.type === "validate" && MESSAGE_USERNAME_UNAVAILABLE,
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            "data-test-id": "email",
                                            type: "email",
                                            autoComplete: "email",
                                            inputLabel: (0,hooks/* useTranslation */.$G)("label_email_address"),
                                            labelFor: "emailAddress"
                                        }, register("email", {
                                            required: true,
                                            // eslint-disable-next-line
                                            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            validate: function() {
                                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
                                                    var available;
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!isSubmitting) {
                                                                    _ctx.next = 2;
                                                                    break;
                                                                }
                                                                return _ctx.abrupt("return", true);
                                                            case 2:
                                                                _ctx.prev = 2;
                                                                _ctx.next = 5;
                                                                return check({
                                                                    email: value
                                                                });
                                                            case 5:
                                                                available = _ctx.sent.available;
                                                                return _ctx.abrupt("return", available);
                                                            case 9:
                                                                _ctx.prev = 9;
                                                                _ctx.t0 = _ctx["catch"](2);
                                                                return _ctx.abrupt("return", true);
                                                            case 12:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee, null, [
                                                        [
                                                            2,
                                                            9
                                                        ]
                                                    ]);
                                                }));
                                                return function(value) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }()
                                        })), {
                                            requiredError: errors.email && errors.email.type === "required",
                                            patternError: errors.email && errors.email.type === "pattern" && MESSAGE_INVALID_EMAIL || errors.email && errors.email.type === "validate" && MESSAGE_EMAIL_UNAVAILABLE,
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            "data-test-id": "password",
                                            type: "password",
                                            autoComplete: "new-password",
                                            inputLabel: (0,hooks/* useTranslation */.$G)("label_password"),
                                            labelFor: "password"
                                        }, register("password", {
                                            required: true,
                                            // eslint-disable-next-line
                                            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/
                                        })), {
                                            requiredError: errors.password && errors.password.type === "required",
                                            patternError: errors.password && errors.password.type === "pattern" && MESSAGE_INVALID_PASSWORD,
                                            patternMessage: (0,hooks/* useTranslation */.$G)("password_pattern_message"),
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            id: "passwordConfirm",
                                            type: "password",
                                            inputLabel: (0,hooks/* useTranslation */.$G)("label_confirm_password"),
                                            labelFor: "passwordConfirm"
                                        }, register("passwordConfirm", {
                                            validate: function(value) {
                                                return value === watch("password");
                                            }
                                        })), {
                                            patternError: errors.passwordConfirm && errors.passwordConfirm.type === "validate" && MESSAGE_PW_MUST_MATCH,
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            labelFor: "country",
                                            options: constants/* LOCATIONS */.Lmo,
                                            selectLabel: (0,hooks/* useTranslation */.$G)("label_location")
                                        }, register("country")), {
                                            isInverted: isInverted
                                        }))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loginCheckboxWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckboxInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                id: "accept",
                                                labelFor: "accept",
                                                checkBoxLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptTermsLabel, {})
                                            }, register("accept", {
                                                required: true
                                            })), {
                                                requiredError: errors.accept && errors.accept.type === "required",
                                                requiredMessage: MESSAGE_MUST_ACCEPT_TOS_TERMS,
                                                classes: {
                                                    checkBoxTextClass: "text-xs"
                                                },
                                                isInverted: isInverted
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loginCheckboxWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: flexCenter,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckboxInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                id: "optin",
                                                labelFor: "optin",
                                                checkBoxLabel: (0,hooks/* useTranslation */.$G)("user_sign_up_opt_in")
                                            }, register("optin")), {
                                                classes: {
                                                    checkBoxTextClass: "text-xs"
                                                },
                                                isInverted: isInverted
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loginButtonWrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            buttonStyle: "primary",
                                            type: "submit",
                                            loading: loading,
                                            className: loginButton,
                                            children: (0,hooks/* useTranslation */.$G)("user_sign_up")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: loginContinueWithWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: loginSignUpWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: loginSignUpText(isInverted),
                            children: (0,hooks/* useTranslation */.$G)("user_have_account")
                        }),
                        pageType === "standalone" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                            href: "/".concat(constants/* ROUTE_OAUTH */.Ggo, "/login"),
                            className: textButton,
                            internalLink: true,
                            children: (0,hooks/* useTranslation */.$G)("user_sign_in")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            buttonStyle: "textButton",
                            type: "button",
                            onClick: function() {
                                return setModalView("LOGIN_VIEW");
                            },
                            className: textButton,
                            children: (0,hooks/* useTranslation */.$G)("user_sign_in")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SignUpView_SignUpView = (/*#__PURE__*/(0,react.memo)(SignUpView));

;// CONCATENATED MODULE: ./components/Auth/SignUpView/index.ts

/* harmony default export */ var Auth_SignUpView = (SignUpView_SignUpView);


/***/ })

}]);